module.exports = __webpack_public_path__ + "i18n/ko_b198c525428b1544d5e07ee19cc267c7.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ko.json
// module id = a8i3
// module chunks = 153